const SHAPE_ICON = {
  Like:
    'M12.622 0.306809C11.5002 0.984 10.5596 2.04794 10 3.34375C9.44044 2.04794 8.49976 0.984 7.37803 0.306809C5.7647 -0.667162 3.74712 -0.852568 1.97259 0.269478L1.97227 0.269685C0.209286 1.38634 -0.59136 3.24927 -0.491708 5.19972C-0.39246 7.14228 0.594596 9.17257 2.39058 10.7136C4.7364 12.7312 7.17657 14.6355 9.71344 16.4097C9.88552 16.5301 10.1145 16.5301 10.2866 16.4097C12.8218 14.6366 15.2657 12.7294 17.6098 10.7133C19.4055 9.17232 20.3925 7.14216 20.4917 5.19972C20.5914 3.24927 19.7907 1.38634 18.0277 0.269685L18.0274 0.269478C16.2529 -0.852568 14.2353 -0.667162 12.622 0.306809Z',
};

const ICON_PATH = {
  // social icons
  email: {
    d:
      'M 2.6001 0L 23.3999 0C 24.8301 0 26 1.18127 26 2.625L 26 18.375C 26 19.8187 24.8301 21 23.3999 21L 2.6001 21C 1.16992 21 0 19.8187 0 18.375L 0.0129395 2.625C 0.0129395 1.18127 1.16992 0 2.6001 0ZM 13 11.8125L 23.4001 5.25L 23.4001 2.625L 13 9.1875L 2.6001 2.625L 2.6001 5.25L 13 11.8125Z',
    width: 26,
    height: 21,
  },
  facebook: {
    d:
      'M40,0H10C4.486,0,0,4.486,0,10v30c0,5.514,4.486,10,10,10h30c5.514,0,10-4.486,10-10V10C50,4.486,45.514,0,40,0z M39,17h-3 c-2.145,0-3,0.504-3,2v3h6l-1,6h-5v20h-7V28h-3v-6h3v-3c0-4.677,1.581-8,7-8c2.902,0,6,1,6,1V17z',
    width: 24,
    height: 24,
  },
  pinterest: {
    d:
      'M 13 0C 5.81682 0 0 5.81682 0 13C 0 18.5045 3.41592 23.2087 8.25676 25.1021C 8.13964 24.0676 8.04204 22.506 8.2958 21.3739C 8.53003 20.3589 9.81832 14.9129 9.81832 14.9129C 9.81832 14.9129 9.42793 14.1321 9.42793 12.9805C 9.42793 11.1652 10.482 9.81832 11.7703 9.81832C 12.8829 9.81832 13.4099 10.6577 13.4099 11.6532C 13.4099 12.7658 12.7072 14.4444 12.3363 15.9865C 12.024 17.2748 12.9805 18.3288 14.2688 18.3288C 16.5721 18.3288 18.3483 15.8889 18.3483 12.3754C 18.3483 9.27177 16.1036 7.08559 12.9219 7.08559C 9.23273 7.08559 7.04655 9.85736 7.04655 12.7267C 7.04655 13.8393 7.47598 15.0496 8.02252 15.6937C 8.12012 15.8303 8.13964 15.9279 8.12012 16.0646C 8.02252 16.4745 7.80781 17.3529 7.76877 17.5285C 7.71021 17.7628 7.57357 17.8213 7.33934 17.7042C 5.71922 16.9429 4.7042 14.5811 4.7042 12.6682C 4.7042 8.56907 7.69069 4.8018 13.2928 4.8018C 17.8018 4.8018 21.2958 8.02252 21.2958 12.2973C 21.2958 16.7673 18.4655 20.3784 14.5616 20.3784C 13.2538 20.3784 12.0045 19.6952 11.5751 18.8949C 11.5751 18.8949 10.9309 21.3739 10.7748 21.979C 10.482 23.1111 9.68168 24.5165 9.15465 25.3949C 10.3649 25.7658 11.6532 25.9805 13 25.9805C 20.1832 25.9805 26 20.1637 26 12.9805C 26 5.81682 20.1832 0 13 0Z',
    width: 26,
    height: 25.9,
  },
  twitter: {
    d:
      'M 8.1768 21.4555C 17.9888 21.4555 23.3542 13.2017 23.3542 6.0446C 23.3542 5.81017 23.3495 5.57679 23.3391 5.34447C 24.3807 4.57992 25.286 3.62581 26 2.5397C 25.0442 2.97108 24.0157 3.26149 22.9366 3.39243C 24.038 2.72187 24.8835 1.6611 25.2824 0.396531C 24.2517 1.01694 23.1103 1.46785 21.8951 1.71126C 20.9216 0.658422 19.5358 0 18.0013 0C 15.0555 0 12.6665 2.42566 12.6665 5.41575C 12.6665 5.84079 12.7133 6.25422 12.8049 6.65075C 8.37131 6.42424 4.44007 4.26892 1.80936 0.991594C 1.35124 1.79205 1.08708 2.72187 1.08708 3.71399C 1.08708 5.59316 2.02881 7.25215 3.4609 8.22262C 2.58573 8.19517 1.7636 7.95123 1.04495 7.54519C 1.04417 7.56792 1.04417 7.59007 1.04417 7.61436C 1.04417 10.2375 2.88291 12.4277 5.32381 12.924C 4.87557 13.0481 4.40392 13.1146 3.9172 13.1146C 3.574 13.1146 3.23963 13.0803 2.91463 13.0169C 3.59376 15.1691 5.56301 16.7351 7.89784 16.7789C 6.0721 18.232 3.77212 19.0974 1.27245 19.0974C 0.842408 19.0974 0.417564 19.0726 0 19.0224C 2.36082 20.5589 5.16417 21.4555 8.17708 21.4555',
    width: 26,
    height: 21.46,
  },
  link: {
    d:
      'M12 24C18.627 24 24 18.6274 24 12C24 5.37256 18.627 0 12 0C5.37305 0 0 5.37256 0 12C0 18.6274 5.37305 24 12 24ZM8.66602 9.93335C7.52637 9.93335 6.59961 10.8601 6.59961 12C6.59961 13.1401 7.52637 14.0667 8.66602 14.0667H11.333V15.3335H8.66602C6.82617 15.3335 5.33301 13.8401 5.33301 12C5.33301 10.1602 6.82617 8.66675 8.66602 8.66675H11.333V9.93335H8.66602ZM12.666 8.66675H15.333C17.1729 8.66675 18.666 10.1602 18.666 12C18.666 13.8401 17.1729 15.3335 15.333 15.3335H12.666V14.0667H15.333C16.4727 14.0667 17.3994 13.1401 17.3994 12C17.3994 10.8601 16.4727 9.93335 15.333 9.93335H12.666V8.66675ZM14.666 12.6667H9.33301V11.3335H14.666V12.6667Z',
    width: 24,
    height: 24,
  },

  // utilities icon starts
  share: {
    d:
      'M 21 7C 22.6567 7 24 5.65686 24 4C 24 2.34314 22.6567 1 21 1C 19.3433 1 18 2.34314 18 4C 18 5.65686 19.3433 7 21 7ZM 21 8C 23.209 8 25 6.20917 25 4C 25 1.79083 23.209 0 21 0C 18.791 0 17 1.79083 17 4C 17 4.62964 17.1455 5.22534 17.4048 5.75525L 7.54004 11.136C 6.86963 9.86578 5.53613 9 4 9C 1.79102 9 0 10.7908 0 13C 0 15.2092 1.79102 17 4 17C 5.21924 17 6.31104 16.4543 7.04492 15.5939L 17.106 21.0817C 17.0366 21.3766 17 21.684 17 22C 17 24.2092 18.791 26 21 26C 23.209 26 25 24.2092 25 22C 25 19.7908 23.209 18 21 18C 19.4644 18 18.1304 18.8657 17.46 20.1357L 7.59521 14.755C 7.85449 14.2252 8 13.6296 8 13C 8 12.6841 7.96338 12.3768 7.89404 12.082L 17.9551 6.59412C 18.689 7.45447 19.7808 8 21 8ZM 4 16C 5.65674 16 7 14.6569 7 13C 7 11.3431 5.65674 10 4 10C 2.34326 10 1 11.3431 1 13C 1 14.6569 2.34326 16 4 16ZM 24 22C 24 23.6569 22.6567 25 21 25C 19.3433 25 18 23.6569 18 22C 18 20.3431 19.3433 19 21 19C 22.6567 19 24 20.3431 24 22Z',
    width: 25,
    height: 26,
    fillRule: 'evenodd',
  },
  loading: {
    d:
      'M 48 24C 48 37.2549 37.2549 48 24 48C 10.7451 48 0 37.2549 0 24C 0 10.7451 10.7451 0 24 0L 24 4C 12.9543 4 4 12.9543 4 24C 4 35.0457 12.9543 44 24 44C 35.0457 44 44 35.0457 44 24L 48 24Z',
    width: 48,
    height: 48,
    fillRule: 'evenodd',
  },
  itemTag: {
    d: 'M0 0H54V18H10L0 0Z',
    width: 54,
    height: 18,
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    viewBox: '0 0 54 18',
    fillOpacity: '0.9',
  },
  discountTag: {
    d: 'M0 0H128V18H16.899L0 0Z',
    width: 128,
    height: 18,
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    viewBox: '0 0 128 18',
    fillOpacity: '0.9',
  },
  backArrow: {
    d:
      'M9.4707 0H10.8848L1.88477 9H24V10H1.94336L10.9434 19H9.5293L0 9.4707L9.4707 0Z',
    width: 24,
    height: 19,
    viewBox: '0 0 24 19',
  },
  cancel: {
    fillRule: 'evenodd',
    d:
      'M7.42462 8.13173L0 0.70711L0.707107 0L8.13173 7.42462L15.5563 0L16.2635 0.70711L8.83884 8.13173L16.2635 15.5564L15.5563 16.2635L8.13173 8.83884L0.707107 16.2635L0 15.5564L7.42462 8.13173Z',
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
  },
  rightArrow: {
    d:
      'M0.275002 15.8583L1.75833 17.3333L10 9.08325L1.75 0.83325L0.275002 2.30825L7.05 9.08325L0.275002 15.8583Z',
    width: 10,
    height: 18,
    viewBox: '0 0 18 18',
  },
  help: {
    d:
      'M6 0C9.3135 0 12 2.6865 12 6C12 9.3135 9.3135 12 6 12C2.6865 12 0 9.3135 0 6C0 2.6865 2.6865 0 6 0ZM4.3985 4.2215C4.542 3.371 5.3695 2.791 6.2495 2.933C7.1265 3.074 7.7165 3.8785 7.5735 4.7265C7.4835 5.059 7.2585 5.269 6.6685 5.6085L6.549 5.6765C5.631 6.2025 5.2535 6.611 5.2535 7.468H6.1645C6.1645 7.0375 6.342 6.8455 7.002 6.4675L7.122 6.3985C7.908 5.947 8.285 5.595 8.4635 4.9185C8.7 3.527 7.7665 2.2545 6.3945 2.0335C5.0245 1.8115 3.7275 2.7205 3.5 4.07L4.3985 4.2215ZM6.2275 9.7465V8.8355H5.3165V9.7465H6.2275Z',
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
  },
  chat: {
    d: 'M1 1V15.5714H7.42857L10 18.5714L12.5714 15.5714H19V1H1Z',
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
  },
  flag: {
    d:
      'm7 0c3.8659932 0 7 3.13400675 7 7 0 3.8659932-3.1340068 7-7 7-.92832697 0-1.81444711-.180709-2.62510239-.5088689l.00075239-4.1578311h6.26255c.21 0 .3512-.2153.2675-.40793l-1.0402-2.39241c-.0323-.07417-.0323-.15841 0-.23259l1.0402-2.39241c.0837-.19263-.0575-.40796-.2675-.40796h-6.26255v-.29167c0-.32216-.26117-.58333-.58333-.58333-.32217 0-.58334.26117-.58334.58333l-.00102452 9.6765824c-1.9301985-1.2463244-3.20795548-3.41640031-3.20795548-5.8849124 0-3.86599325 3.13400675-7 7-7z',
    height: 14,
    width: 14,
    viewBox: '0 0 14 14',
  },
  alert: {
    d:
      'm10 0c5.5228475 0 10 4.4771525 10 10s-4.4771525 10-10 10-10-4.4771525-10-10 4.4771525-10 10-10zm-.1517 13.0619c-.6987 0-1.2545.5559-1.2545 1.232s.5558 1.2169 1.2545 1.2169c.676 0 1.2394-.5408 1.2394-1.2169s-.5634-1.232-1.2394-1.232zm1.1268-8.9994h-2.2011l.3606 7.7374h1.4799z',
    height: 20,
    width: 20,
    viewBox: '0 0 20 20',
  },
  success: {
    d:
      'm10.75 0c5.5228475 0 10 4.4771525 10 10s-4.4771525 10-10 10-10-4.4771525-10-10 4.4771525-10 10-10zm3.9696699 6.46966991-5.4696699 5.46933009-2.46966991-2.46933009-1.06066018 1.06066019 3.53033009 3.5303301 6.5303301-6.53033011z',
    height: 20,
    width: 21,
    viewBox: '0 0 21 20',
  },
};

module.exports = {
  ICON_PATH,
  SHAPE_ICON,
};
